import actionTypes from '../constants/action-types';

const setSession = (site) => ({
  type: actionTypes.SET_SESSION,
  payload: {
    site,
  },
});

export default setSession;
